/* =============================================================================
   custom-ydp.js
   -------------
   All YES Dental Parts custom JavaScript lives here.
   Do not edit core theme JS files — add custom logic below.
   ============================================================================= */

document.addEventListener('DOMContentLoaded', function () {

  // Default collection pages to list view when no explicit view param is set.
  // The primary default is set in templates/collection*.json (default_view: list-view).
  // This safety net handles any collection URL that bypasses those templates.
  if (window.location.pathname.includes('/collections/')) {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('grid_list')) {
      params.set('grid_list', 'list-view');
      window.location.replace(window.location.pathname + '?' + params.toString());
    }
  }

  // Variant option notes: move them directly under the option buttons.
  var notes = document.querySelector('[data-ydp-variant-notes]');
  if (notes) {
    var lastOption = Array.prototype.slice.call(document.querySelectorAll('[data-product-form-area] [data-variant-option]')).pop();
    if (lastOption) lastOption.insertAdjacentElement('afterend', notes);
  }

});

/* -----------------------------------------------------------------------------
   Product page variant changes
   1. Dealer pricing: Empire rewrites the price with the full variant price
      when a buyer switches options. For WS20/WS25/WS30 customers, re-apply
      the dealer price afterwards (multiplier from custom-ydp-dealer-pricing).
   2. Variant images: product.gallery.liquid only renders the selected
      variant's image (plus shared images). On option change, fetch the page
      for the new variant and swap in its freshly rendered gallery.
   3. Variant option notes: show only the selected variant's note.
   ----------------------------------------------------------------------------- */
(function () {
  var productJsonPromise = null;
  var galleryCache = {};

  function getProductJson() {
    if (!productJsonPromise) {
      var path = window.location.pathname.replace(/\/$/, '');
      productJsonPromise = fetch(path + '.js').then(function (r) { return r.json(); });
    }
    return productJsonPromise;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, (window.Shopify && Shopify.money_format) || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function currentVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var idField = form && form.querySelector('[name="id"]');
    return idField ? Number(idField.value) : null;
  }

  function applyDealerPrice(variantId) {
    var mult = window.WS_DISCOUNT_MULTIPLIER || 1;
    if (mult >= 1 || !variantId) return;

    getProductJson().then(function (product) {
      var variant = (product.variants || []).find(function (v) { return v.id === variantId; });
      if (!variant) return;

      document.querySelectorAll('[data-product-pricing]').forEach(function (pricing) {
        var compare = pricing.querySelector('[data-price-compare-container]');
        var compareMoney = compare && compare.querySelector('[data-price-compare]');
        var priceMoney = pricing.querySelector('[data-price-container] [data-price]');

        if (compare && compareMoney) {
          compareMoney.innerHTML = formatMoney(variant.price);
          compare.classList.add('visible');
        }
        if (priceMoney) {
          priceMoney.innerHTML = formatMoney(Math.round(variant.price * mult));
          priceMoney.classList.add('sale-price');
        }
      });
    }).catch(function () {});
  }

  function swapGallery(variantId) {
    var gallery = document.querySelector('product-gallery[data-ydp-variant-id]');
    if (!gallery || !variantId) return;
    if (Number(gallery.dataset.ydpVariantId) === variantId) return;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    var key = url.toString();

    if (!galleryCache[key]) {
      galleryCache[key] = fetch(key)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('product-gallery[data-ydp-variant-id]');
        });
    }

    galleryCache[key].then(function (fresh) {
      if (!fresh) return;
      // Re-check the live variant in case the buyer clicked again meanwhile
      if (currentVariantId() !== variantId) return;
      var live = document.querySelector('product-gallery[data-ydp-variant-id]');
      if (!live) return;
      live.replaceWith(document.importNode(fresh, true));
    }).catch(function () {});
  }

  function updateVariantNotes(variantId) {
    document.querySelectorAll('[data-ydp-variant-note]').forEach(function (note) {
      note.hidden = Number(note.dataset.ydpVariantNote) !== variantId;
    });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.closest || !event.target.closest('[data-product-form-area], form[action*="/cart/add"]')) return;
    // Let Empire finish its own update first
    setTimeout(function () {
      var variantId = currentVariantId();
      updateVariantNotes(variantId);
      applyDealerPrice(variantId);
      swapGallery(variantId);
    }, 80);
  });
})();
